exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background{\r\n\t/*background: #E5E5E5;*/\r\n\t/* min-height should be removed */\r\n\tmin-height: 400px;\r\n}\r\n.pr0 {\r\n\tpadding-right: 0;\r\n}\r\n.pl0 {\r\n\tpadding-left: 0;\r\n}\r\n.malign {\r\n\tmargin-top: 30px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1